import { useContentSelector } from '@wajeez-web/stores/content';

export const useGetAuthorByIdMultilingual = () => {
  return useContentSelector(({ authors }) => authors.byIdMultilingual);
};

export const useCreateAuthorMultilingual = () => {
  return useContentSelector(({ authors }) => authors.createMultilingual);
};

export const useEditAuthorMultilingual = () => {
  return useContentSelector(({ authors }) => authors.editMultilingual);
};
